import React from 'react';
import ReactDOM from 'react-dom/client';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import { ru } from 'date-fns/locale';
import './index.css';
import './styles/animations.css';
import './appglobals.css'; // Modern UI styles
import App from './App.tsx';

// Register Chart.js components to fix "linear" and "arc" registration errors
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  LineController,
  BarController,
  DoughnutController,
  Filler
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

// Единый календарь во всём продукте: русский язык и неделя с понедельника.
// Все компоненты DatePicker наследуют эту настройку.
registerLocale('ru', ru);
setDefaultLocale('ru');

// Register all required Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  LineController,
  BarController,
  DoughnutController,
  Filler,
  ChartDataLabels
);

// Инициализация Sentry или других аналитики в продакшене
if (process.env.NODE_ENV === 'production') {
    console.log('🚀 Avito Marketing Analytics Dashboard loaded');
}

const root = ReactDOM.createRoot(document.getElementById('root'));

// Рендерим корневое приложение
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Hot Module Replacement для разработки
if (module.hot) {
    module.hot.accept('./App.tsx', () => {
        const NextApp = require('./App.tsx').default;
        root.render(
            <React.StrictMode>
                <NextApp />
            </React.StrictMode>
        );
    });
}
